<div class="h-full overflow-y-auto px-8">
  <div class="flex items-center justify-between py-4 mt-2">
    <span class="title-t1">{{'statistics.title' | translate}}</span>
  </div>

  <!-- Filter dates -->
  <div class="flex items-center gap-4 mb-2">
    <mat-form-field appearance="outline" class="statistics-date-field">
      <mat-label>{{'statistics.dateFrom' | translate}}</mat-label>
      <input matInput type="date" required [max]="dateTo" [(ngModel)]="dateFrom" (input)="onDateInput($event, 'from')" (keyup.enter)="loadSummary()" data-cy="statistics-date-from">
    </mat-form-field>

    <mat-form-field appearance="outline" class="statistics-date-field">
      <mat-label>{{'statistics.dateTo' | translate}}</mat-label>
      <input matInput type="date" required [min]="dateFrom" [(ngModel)]="dateTo" (input)="onDateInput($event, 'to')" (keyup.enter)="loadSummary()" data-cy="statistics-date-to">
    </mat-form-field>

    <button mat-raised-button color="primary" [disabled]="!!dateError || loading" (click)="loadSummary()" data-cy="statistics-query">{{'statistics.query' | translate}}</button>
    <button mat-raised-button color="primary" [disabled]="!!dateError" (click)="downloadCsv()" data-cy="statistics-download-csv">{{'statistics.downloadCsv' | translate}}</button>
  </div>
  <div *ngIf="dateError" class="text-sm mb-4" style="color: var(--error-500)" data-cy="statistics-date-error">{{'statistics.dateErrors.' + dateError | translate}}</div>
  <div *ngIf="!dateError" class="text-sm text-gray-500 mb-4" data-cy="statistics-range-info">
    <ng-container *ngIf="appliedRange; else notQueriedTpl">
      {{'statistics.appliedRange' | translate: appliedRange}}
      <span *ngIf="datesChanged"> · {{'statistics.datesChanged' | translate}}</span>
    </ng-container>
    <ng-template #notQueriedTpl>{{'statistics.queryHint' | translate}}</ng-template>
  </div>

  <!-- Summary cards -->
  <ng-container *ngIf="!loading; else loadingTpl">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" *ngIf="appliedRange">
      <div *ngFor="let metric of metrics"
           class="bg-white rounded-lg shadow p-6 cursor-pointer hover:shadow-lg transition-shadow border border-gray-200"
           (click)="openDetail(metric.key, metric.label)"
           [attr.data-cy]="'statistics-card-' + metric.key">
        <div class="text-sm font-medium text-gray-500 uppercase tracking-wide">{{ metric.label }}</div>
        <div class="text-4xl font-bold mt-2 text-gray-800">{{ summary[metric.key] ?? 0 }}</div>
      </div>
    </div>
  </ng-container>

  <ng-template #loadingTpl>
    <div class="flex justify-center py-12">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </ng-template>
</div>
